import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Map from './components/Map'; // Ensure this is the updated Map component
import CardList from './components/CardList';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebaseConfig'; // Adjust the import path as needed

const App = () => {
  
  const [places, setPlaces] = useState([]);

  useEffect(() => {
    const fetchPlaces = async () => {
      const placesCollection = collection(db, 'places');
      const snapshot = await getDocs(placesCollection);
      const placesData = snapshot.docs.map(doc => doc.data());
      setPlaces(placesData);
    };

    fetchPlaces();
  }, []);

  return (
  <Container maxWidth="xl" sx={{ py: 4 }}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Map places={places}/>
      </Grid>
      <Grid item xs={12}>
        <CardList places={places}/>
      </Grid>
    </Grid>
  </Container>
);
}

export default App;
